import React, { useEffect, useState, useContext } from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import envConfig from '@nile/home/src/Config/env';
import Auth from '@nile/home/src/Auth/Auth';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import {
  AppContext,
  AppLoader,
  checkForMobileOrTabBrowser,
  COMMON_CONSTANTS,
  useProduct
} from '@nile/components';
import Monitor from '@nile/home/src/Monitor';
import AppNetworkStatus from '@nile/components/src/Pebbles/AppNetworkStatus';
import { useAppcuesTrigger } from '@nile/components/src/Utils/appcuesUtil'; // Appcues Trigger Util
import { savePersonalization } from '@nile/graphql';


function PrivateRoute(props) {
  const { flags, component: Component, layout: Layout, ...rest } = props;
  const appContext = useContext(AppContext);
  const { user, currentServicePortal } = appContext;
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);

  const [loading, setLoading] = useState(false);
  const [previousLocation, setPreviousLocation] = useState('');
  const [openOnboardModal, setOpenOnboardModal] = useState(false);

  useEffect(() => {
    if (Auth.isAuthenticated && sessionStorage.getItem('redirectUrl')) {
      sessionStorage.removeItem('redirectUrl');
      sessionStorage.removeItem('redirectUrlParams', props.location.search);
    }
    if (!Auth.isAuthenticated && !sessionStorage.getItem('redirectUrl')) {
      sessionStorage.setItem('redirectUrl', props.location.pathname);
      sessionStorage.setItem('redirectUrlParams', props.location.search);
    }
    setPreviousLocation(props.location.pathname);

    //Checking for mobile browser and redirecting to app
    let isValid = checkForMobileOrTabBrowser();
    let location = window.location;

    if (
      isValid &&
      (props.location.pathname.includes('/tickets') ||
        props.location.pathname.includes('/asset/'))
    ) {
      let userAgent = navigator.userAgent || window.opera;
      let redirectionURL = `${location.hostname}/#${props.location.pathname}`;
      if (/android/i.test(userAgent)) {
        const url = `intent://${redirectionURL}/#Intent;scheme=superops;package=com.superops_mobile_app;end`;
        location.replace(url);
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        const url = `superops://${redirectionURL}`;
        location.replace(url);
      }
    }
  }, []);


  const checkForRedirect = () => {
    if (
      props?.location?.pathname?.startsWith('/kb/article/') ||
      props?.location?.pathname?.startsWith('/home')
    ) {
      setLoading(true);
      const url = props.location?.pathname;
      const parts = url.split('/');
      const id = parts[3];
      window.location.replace(id ? `/#/client-home/${id}` : `/#/client-home`);
      setLoading(false);
    }
  };

  const handleServicePortalChange = async () => {
    try {
      setLoading(true);
      let updatedServicePortal = COMMON_CONSTANTS.TECHNICIAN;

      if (currentServicePortal === COMMON_CONSTANTS.TECHNICIAN) {
        updatedServicePortal = COMMON_CONSTANTS.REQUESTER;
      } else {
        updatedServicePortal = COMMON_CONSTANTS.TECHNICIAN;
      }
      const personalisedData = {
        name: 'CurrentServicePortal',
        category: 'currentServicePortalPersonalization',
        value: updatedServicePortal,
        user: {
          firstName: user.firstName,
          userId: user.userId,
          email: user.email,
          lastName: user.lastName
        }
      };
      await savePersonalization({
        variables: personalisedData,
        input: personalisedData
      });
      localStorage.setItem('currentServicePortal', updatedServicePortal);
      window.location.reload();
    } catch (ex) {
      console.error(ex);
    } finally {
      setLoading(false);
    }
  };

  const switchToTechPortal = () => {
    const hasTechPortalAccess = user?.roles?.some(
      (role) => role?.roleType?.type === COMMON_CONSTANTS.TECHNICIAN
    );
    const isRequesterRole = user?.roles?.some(
      (role) => role?.roleType?.type === COMMON_CONSTANTS.REQUESTER
    );
    if (!isMSPProduct && window.location.hash.includes('/agent/marketplace')) {
      if (hasTechPortalAccess) {
        handleServicePortalChange();
      } else {
        window.location.replace('/#/client-home');
      }
    }
    if (
      isMSPProduct &&
      window.location.hash.includes('/agent/marketplace') &&
      isRequesterRole
    ) {
      window.location.replace('/#/client-home');
    }
  };

  useEffect(() => {
    // Onboard appcues modal trigger from website signup form
    // if (flags?.appcuesReferrer) {
    // useAppcuesTrigger(document.referrer, 'referrer');
    // }

    if (flags?.onBoardingCbFe && !flags?.postSignupForm) {
      useAppcuesTrigger(document.referrer, 'referrer');
    }
  }, [flags]);

  useEffect(() => {
    if (user?.accountType === 'CLIENT') {
      checkForRedirect();
      switchToTechPortal();
    }
    if (previousLocation !== props?.location?.pathname) {
      setPreviousLocation(props.location.pathname);
      if (envConfig.mode !== 'development') {
        // Intercom update
        window.Intercom('update');
      }
    }
  }, [props.location?.pathname]);

  if (loading) {
    return (
      <div className="vh100 flex center jctr">
        <AppLoader showLetNav />
      </div>
    );
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        Auth.isAuthenticated ? (
          <Layout routeComponent={<Component {...props} />}>
            <Monitor user={user} flags={flags}></Monitor>
            <AppNetworkStatus flags={flags} />
          </Layout>
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
}
export default withRouter(withLDConsumer()(PrivateRoute));
